import { Controller } from '@hotwired/stimulus';

export default class SddMandateController extends Controller {
  static targets = [
    'step1Success',
    'step1Failure',
    'step1FailureMessage',
    'step2',
    'step2Error',
    'generatingIcon',
    'generatedIcon',
    'generatingExplanations',
    'generatingReady',
    'contractLoadedButton',
    'contractSignButton',
  ];

  static values = {
    universignEndpoint: String,
    kycValidated: Boolean,
  };

 connect() {
    if (!window.universignSigInit) {
      this.#loadUniversignScript();
    }

    this.subscription = App.cable.subscriptions.create(
      { channel: 'SddMandateChannel', id: this.userIdValue },
      { received: this.#received.bind(this) }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  createMandate() {
    if (!this.kycValidatedValue) {
      return;
    }
    this.subscription.perform('create_mandate', {});
  }

  onSignClick(event) {
    event.preventDefault();
    const mandateId = this.element.dataset.id;
    if (mandateId) {
      this.subscription.perform('initiate_signature', { mandate_id: mandateId });
    }
  }

  #received(data) {
    switch (data.action) {
      case 'mandate_created':
        this.#handleMandateCreated(data.mandate_id)
        break
      case 'mandate_creation_failed':
        this.#handleMandateCreationFailed(data.message)
        break
      case 'signature_initiated':
        this.#handleSignatureInitiated(data.e_sign_id)
        break
      case 'signature_initiation_failed':
        this.#handleSignatureInitiationFailed()
        break
      default:
    }
  }

  #handleMandateCreated(mandateId) {
    this.element.dataset.id = mandateId;

    this.generatingIconTarget.classList.add('d-none');
    this.generatingExplanationsTarget.classList.add('d-none');
    this.contractLoadedButtonTarget.classList.add('d-none');

    this.generatedIconTarget.classList.remove('d-none');
    this.generatingReadyTarget.classList.remove('d-none');
    this.contractSignButtonTarget.classList.remove('d-none');
    this.contractSignButtonTarget.disabled = false;
  }

  #handleMandateCreationFailed(error_message) {
    this.step1SuccessTarget.classList.add('d-none');
    this.step1FailureMessageTarget.textContent = error_message;
    this.step1FailureTarget.classList.remove('d-none');
  }

  #handleSignatureInitiated(signerId) {
    this.step1SuccessTarget.classList.add('d-none');
    this.step2Target.classList.remove('d-none');

    universignSigInit('sepa-mandate-step-2', signerId, {}, this.universignEndpointValue);
  }

  #handleSignatureInitiationFailed() {
    this.step1SuccessTarget.classList.add('d-none');
    this.step2ErrorTarget.classList.remove('d-none');
  }

  #loadUniversignScript() {
    const script = document.createElement("script");
    script.src = `${this.universignEndpointValue}/sig/embed.js`;
    document.head.appendChild(script);
  }
}
